import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import BracketGameModel from "./BracketGameModel";

export default class BracketGamesModel {
  public meta: MetaModel = new MetaModel();
  public data: BracketGameModel[] = [];
}
